import { render, staticRenderFns } from "./professtional.vue?vue&type=template&id=4a7fd006&scoped=true&"
import script from "./professtional.vue?vue&type=script&lang=js&"
export * from "./professtional.vue?vue&type=script&lang=js&"
import style0 from "./professtional.vue?vue&type=style&index=0&id=4a7fd006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7fd006",
  null
  
)

export default component.exports